// ProductListProvider.js
import {useSearchParams} from "react-router-dom";
import {ProductCollectionComponent} from "./ProductCollectionComponent";
import React from "react";
import {ProductCollectionComponentSetareh} from "./customeMerketDesign/setareh/ProductCollectionComponentSetareh";

export default function ProductListProvider() {
    const [searchParams] = useSearchParams();

    const marketId = searchParams.get('id');
    var catParam = searchParams.get('cat'); // e.g. "12,13,14"

    if (catParam && catParam === "1252") {
        catParam = "3935,3942,3950,3951,3952"
    }

    const initialCategories = catParam
        ? catParam.split(',').map(s => s.trim()).filter(Boolean)
        : [];

    switch (marketId) {
        case "5108":
            return (
                <ProductCollectionComponentSetareh
                    id={marketId}
                    initialCategories={initialCategories}  // <-- NEW
                />
            );

        default:
            return (
                <ProductCollectionComponent
                    id={marketId}
                    initialCategories={initialCategories}  // <-- NEW
                />
            );
    }

}
